import { Price, PriceAdd } from "@/types/sales";
import {
  isPrice,
  isString,
  isStringEmpty,
} from "@/utils/checkTool";
import request from ".";
import { cleanToPrice } from "@/utils/cleanData";
import { CommonListParams } from "@/types/common";
import { Bom, BomAdd, BomApi } from "@/types/bom";
import { AxiosRequestConfig } from "axios";
import { transferBomApiToBom } from "@/pages/Bom/util";

const url = "/wms/bom";

const apis = {
  add: `${url}/add`,
  import: `${url}/import`,
  replace: (id: string) => `${url}/${id}/replace`,
  del: (id: string) => `${url}/${id}/del`,
  fetch: (id: string) => `${url}/${id}/fetch`,
  list: `${url}/list`,
  fetchs: `${url}/fetchs`,
  his: (id: string) => `${url}/${id}/his`,
};

export const addBom = (body: BomAdd) => {

  return request<Bom, BomAdd>(apis.add, {
    params: { body },
  })
    .then(({ body: bom }) => {
      return Promise.resolve(bom);
    })
    .catch((err) => Promise.reject(err));
};

export const importBom = (file: FormData, config: AxiosRequestConfig) => {
  return request<Bom, string>(apis.import, {
    params: file,
    requestConfig: config
  })
};

export const fetch = (id: string) => {
  return new Promise<Bom>((resolve, reject) => {
    if (!isString(id) || isStringEmpty(id)) {
      return Promise.reject(10012);
    }
    request<BomApi, string>(apis.fetch(id))
      .then(({ body: detail }) => resolve(transferBomApiToBom(detail)))
      .catch((err) => reject(err));
  });
};

export const del = (id: string) => {
  return new Promise<void>((resolve, reject) => {
    if (!isString(id) || isStringEmpty(id)) {
      return Promise.reject(10012);
    }
    request<void, void>(apis.del(id))
      .then(() => resolve())
      .catch((err) => reject(err));
  });
};

export const list = (params?: CommonListParams<string>) => {
  if (params && params.body && !isString(params.body)) {
    return Promise.reject(10012);
  }
  return request<Array<BomApi>, string>(apis.list, { params })
    .then((res) => {
      const info = res.body.map(transferBomApiToBom)
      return Promise.resolve({ body: info, pagination: res.pagination })
    })
    .catch(err => Promise.reject(err))
};

export const fetchs = (params?: CommonListParams<string>) => {
  if (params && params.body && !isString(params.body)) {
    return Promise.reject(10012);
  }
  return request<Array<BomApi>, string>(apis.fetchs)
    .then((res) => {
      const info = res.body.map(transferBomApiToBom)
      return Promise.resolve({ body: info, pagination: res.pagination })
    })
    .catch(err => Promise.reject(err))
};

// export const update: (props: PriceAdd, id: string) => Promise<void> = (
//   props,
//   id
// ) => {
//   return new Promise((resolve, reject) => {
//     if (
//       !isString(id) ||
//       (isStringEmpty(id) && props.price && !isString(props.price))
//     ) {
//       return reject(10012);
//     }
//     request<void, PriceAdd>(apis.update(id), {
//       params: { body: props },
//     })
//       .then(() => resolve())
//       .catch(() => reject());
//   });
// };

// export interface UpdateByKey {
//   key: PriceUpdateKey;
//   value: string;
// }

// export const updateByKey = (id: string, props: UpdateByKey) => {
//   return new Promise<void>((resolve, reject) => {
//     if (
//       (!isString(id) || isStringEmpty(id)) &&
//       props.key &&
//       !isString(props.key)
//     ) {
//       return reject(10012);
//     }
//     request<void, string>(apis.updateByKey(id, props.key), {
//       params: { body: props.value },
//     })
//       .then(() => resolve())
//       .catch((err) => reject(err));
//   });
// };

const exportObject = {
  importBom,
  fetchs,
  list,
  del,
  fetch
};

export default exportObject;
